import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import LocalizedText from '@LocalizedText';
import './LabeledToggle.scss';

const LabeledToggle = ({
  onChange,
  options: [ firstOption, secondOption ],
  small,
  checked,
}) => <div className={classnames("labeled-toggle", { small })} data-testid="labeled-toggle">
  <input id={`firstOption-${firstOption}`} type="radio" value={firstOption} onChange={onChange} checked={checked === firstOption} />
  <label htmlFor={`firstOption-${firstOption}`} className="label">
    <LocalizedText id={`qau-${firstOption}-toggle-label-text`} />
  </label>
  <input id={`secondOption-${secondOption}`} type="radio" value={secondOption} onChange={onChange} checked={checked === secondOption} />
  <label htmlFor={`secondOption-${secondOption}`} className="label">
    <LocalizedText id={`qau-${secondOption}-toggle-label-text`} />
  </label>
</div>;

LabeledToggle.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  checked: PropTypes.string.isRequired,
};

export default LabeledToggle;